import type { FC } from 'react';

import useDatesAndConfig from './dates-and-config-hooks';
import DatesAndConfigScene from './dates-and-config-scene';

type DatesAndConfigProps = {
  orderHasAccountingData: boolean
}

const DatesAndConfig: FC<DatesAndConfigProps> = () => {
  const {
    transactionTypes,
    workflows,
    methods,
    parties,
    settelmentStatements,
    estatesMap,
    loansMap,
    purchasePriceEntries,
    loanAmountEntries,
  } = useDatesAndConfig();

  return (
    <DatesAndConfigScene
      transactionTypes={transactionTypes}
      workflows={workflows}
      settelmentStatements={settelmentStatements}
      methods={methods}
      parties={parties}
      estatesMap={estatesMap}
      loansMap={loansMap}
      purchasePriceEntries={purchasePriceEntries}
      loanAmountEntries={loanAmountEntries}
    />
  );
};

export default DatesAndConfig;
